// Mock API for demonstration purposes when backend is not available
export const mockAPI = {
  // Mock onboarding endpoint
  onboarding: async (data) => {
    console.log('Mock onboarding:', data);
    return { success: true, message: 'Mock onboarding completed' };
  },

  // Mock venues endpoint  
  venues: async (data) => {
    console.log('Mock venues request:', data);
    return {
      venues: [
        {
          id: 'mock_1',
          name: 'Sample Art Museum',
          description: 'A beautiful art museum showcasing contemporary works',
          category: 'museum',
          coordinates: [37.7749, -122.4194],
          address: '123 Art Street, San Francisco, CA',
          rating: 4.5,
          price_range: '$$',
          hours: { monday: '10:00-18:00', tuesday: '10:00-18:00' },
          images: [],
          tags: ['contemporary', 'sculpture', 'painting'],
          qloo_score: 0.95
        },
        {
          id: 'mock_2', 
          name: 'Jazz Corner Club',
          description: 'Intimate jazz venue with live performances',
          category: 'music_venue',
          coordinates: [37.7849, -122.4094],
          address: '456 Music Ave, San Francisco, CA',
          rating: 4.7,
          price_range: '$$$',
          hours: { monday: '19:00-24:00', tuesday: '19:00-24:00' },
          images: [],
          tags: ['jazz', 'live music', 'intimate'],
          qloo_score: 0.92
        }
      ]
    };
  },

  // Mock taste extraction
  extractTastes: async (data) => {
    console.log('Mock taste extraction:', data);
    return {
      extracted_tastes: ['art', 'music', 'culture'],
      confidence_scores: { art: 0.9, music: 0.8, culture: 0.85 }
    };
  },

  // Mock route refinement
  refineRoute: async (data) => {
    console.log('Mock route refinement:', data);
    return {
      refined_route: [],
      ai_explanation: 'This is a mock response for demonstration purposes.'
    };
  }
};

// Function to determine if we should use mock API
export const shouldUseMockAPI = () => {
  // You can change this logic based on environment or other conditions
  return process.env.REACT_APP_USE_MOCK_API === 'true' || 
         !process.env.REACT_APP_API_BASE_URL ||
         process.env.REACT_APP_API_BASE_URL.includes('placeholder');
};
